import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

type Params = {
  fileId?: string
  fileSlug?: string
}

export default async function getPrivateFile({ fileId, fileSlug }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/file/private-file/private-file/${fileId}/${fileSlug}`,
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
